import classNames from "classnames";
import { styled } from "@schaeffler-commerce/design-system";
import type { CMSListProps } from "~/features/cms/types/props";
import { createMarkup, renderAsHTML } from "~/features/cms/utils/markup";

// Migrated from CMSSection.less (.scha__cmssection__sub-element__headline):
// margin-top @spacing (16px), margin-bottom 0. The marker class stays as a
// styling hook: CMSTeasers' details target resets the margin-top to 0 for
// lists inside the teaser dropdown (migrated CMSTeasers.less rule).
const Subheadline = styled("h3")(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: 0,
}));

export const CMSList = (props: CMSListProps) => {
  const { content, subHeadline, className } = props;
  return (
    <div className={classNames("scha__cms scha__cmssection__sub--list", className)}>
      {/* This h3 is styled like a h6 in the designs */}
      {subHeadline && !!subHeadline.length && (
        <Subheadline
          className={"scha__cmssection__sub-element__headline headline_h6_left"}
          dangerouslySetInnerHTML={createMarkup(subHeadline)}
        />
      )}
      {content && !!content.length && renderAsHTML(content)}
    </div>
  );
};
